import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

// PictureViewer: generic image viewer for report data
// Accepts either base64 image or URL, with optional meta: { size, placement, overlay_text }
const PictureViewer = ({ data }) => {
  if (!data) return null;

  const base = data?.analysisData || data?.data || data?.result || data?.content || data || {};
  const b64 = base?.b64_image || '';
  const url = base?.url || '';
  const meta = base?.meta || {};
  const size = base?.size || meta?.size || '';

  const src = b64 ? `data:image/png;base64,${b64}` : url || '';
  if (!src) return null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
      <Box sx={{ position: 'relative', maxWidth: '90%', maxHeight: '70vh' }}>
        <Box
          component="img"
          src={src}
          alt="image"
          sx={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 1, border: (theme) => `1px solid ${theme.palette.divider}` }}
        />
        <IconButton
          size="small"
          onClick={() => {
            const a = document.createElement('a');
            a.href = src;
            a.download = `${meta?.placement || 'image'}-${Date.now()}.png`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          }}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            bgcolor: 'rgba(0,0,0,0.4)',
            color: '#fff',
            '&:hover': { bgcolor: 'rgba(0,0,0,0.6)' }
          }}
        >
          <DownloadIcon />
        </IconButton>
      </Box>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {size ? `Size: ${size}` : null} {meta?.placement ? `• Placement: ${meta.placement}` : ''}
      </Typography>
      {meta?.overlay_text ? (
        <Typography variant="caption" sx={{ color: 'text.secondary', whiteSpace: 'pre-wrap' }}>
          {meta.overlay_text}
        </Typography>
      ) : null}
    </Box>
  );
};

export default PictureViewer;
